<div
  class="user-cursor"
  *ngFor="let c of cursors; index as i; trackBy: trackByUser"
  [ngStyle]="c"
  [inlineSVG]="'img/cursor.svg'"
></div>
